module.exports = __webpack_public_path__ + "static/media/14UNEP9.3a8a463f.jpg";